module.exports = __webpack_public_path__ + "static/media/case-study-2.e483f6ef.pdf";